import BaseViz from './BaseViz'
import LineAndBarChartChart from '../charts/LineAndBarChartChart'
import LineAndBarDataController from '../viz_behaviors/LineAndBarDataController'
export default class LineAndBarChartViz extends BaseViz {
  static chartClass = LineAndBarChartChart
  static dataControllerClass = LineAndBarDataController
  static defaultConfig = {
    roleDict: {
      type: [Object, null],
      default: null,
      exposed: false,
    },
    ItemsHelper: {
      // me lo llevo a los components! Simple/Multiple
      // colorScale: {
      //   nonEditable: [true, false],
      //   value: ['categorical2', 'categorical'],
      //   options: [['categorical2'], ['categorical', 'single']],
      //   multiValueIds: ['Lines', 'Bars'],
      // },
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
        side: {
          nonEditable: true,
        },
      },
      x: {
        side: {
          nonEditable: true,
        },
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        scale: {
          nonEditable: true,
          exposed: false,
        },
        domain: {
          nonEditable: true,
        },
      },
    },
  }
}
